.l{overflow:hidden;}